export default {
    actionRequested: 'Acción Requerida',
    cancelationPending: 'Cancelación Pendiente',
    disputeApproved: 'Disputa Aprobada',
    disputeCanceled: 'Disputa Cancelada',
    disputeCompleted: 'Disputa Completada',
    disputeDenied: 'Disputa Denegada',
    disputeOpened: 'Disputa Abierta',
    disputeUnderReview: 'En Revisión',
    temporaryCredit: 'Crédito Temporal'
};
//# sourceMappingURL=transactionStatus.js.map